import React, { useState, useEffect, useContext } from "react";

import { BarbershopContext } from "../../../providers/useProvider";
const ChooseStaff = ({
  staffList,
  selectedStaff,
  onSelectStaff,
  availabelStaffList,
}) => {
  const [loading, setLoading] = useState(true);
  const imageBaseUrl = process.env.REACT_APP_Image_APP_URL;

  if (!staffList) {
    return <h1>Loading..</h1>;
  }

  return (
    <>
      <h3 className="mb-4">Choose a Staff Member</h3>
      <div className="row">
        {staffList.map((staff) => {
          const isSelected = selectedStaff?.id === staff.id;
          const normalizedIds = availabelStaffList.map((id) =>
            id.toLowerCase(),
          );
          const isDisabled = !normalizedIds.includes(staff.id.toLowerCase());

          return (
            <div key={staff.id} className="col-sm-6 col-md-4 mb-4">
              <div
                className={`card h-100 text-center shadow-sm ${
                  isSelected ? "border-primary" : ""
                }`}
                onClick={() => {
                  if (!isDisabled) {
                    onSelectStaff(staff);
                  }
                }}
                style={{
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  pointerEvents: isDisabled ? "none" : "auto",
                }}
              >
                <img
                  src={`${imageBaseUrl}${staff.photoUrl}`}
                  className="card-img-top img-fluid"
                  alt={staff.name}
                  style={{ height: "220px", objectFit: "cover" }}
                />
                <div className="card-body">
                  <h5 className="card-title">{staff.name}</h5>
                </div>
              </div>
              {isDisabled && (
                <div>
                  <p className="card-text">
                    Unavailable for selected service(s)
                  </p>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
};
export default ChooseStaff;
